import React, { useState } from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import FolderNameInputModalView from "presentational/common/modals/FolderNameInputModalView";
import TXT from "presentational/common/multinational/TXT";
import config from "lib/fr-config";
import PropTypes from "prop-types";

const colorCss = config.css.color;

PickAndBookmarkFolderOptModalView.propTypes = {
  open: PropTypes.bool.isRequired,
  nowFolderInfo: PropTypes.object.isRequired,
  onFolderCreateBtnSubmit: PropTypes.func.isRequired,
  onFolderEditBtnSubmit: PropTypes.func.isRequired,
  onFolderDeleteBtnSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

function PickAndBookmarkFolderOptModalView(props) {
  const {
    open,
    nowFolderInfo,
    onFolderCreateBtnSubmit,
    onFolderEditBtnSubmit,
    onFolderDeleteBtnSubmit,
    onClose
  } = props;
  const [inputModalOpen, setInputModalOpen] = useState(false);
  const [inputModalType, setInputModalType] = useState("create");
  const [inputFolderName, setInputFolderName] = useState(null);
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);

  const getButtonList = () => {
    const rawButtonList = [
      {
        type: "necessary",
        primary: <TXT name="btnList_createFolder" />,
        secondary: null,
        func: handleFolderCreateClick
      },
      {
        type: "not-all",
        primary: (
          <TXT
            name="btnList_editFolderName"
            input={{ folderName: nowFolderInfo.name }}
          />
        ),
        secondary: null,
        func: handleFolderEditClick
      },
      {
        type: "not-all",
        primary: (
          <TXT
            name="btnList_removeFolder"
            input={{ folderName: nowFolderInfo.name }}
          />
        ),
        secondary: null,
        func: handleFolderDeleteClick
      }
    ];

    const returnArr = rawButtonList.filter(btn => {
      if (btn.type === "necessary") {
        return true;
      } else if (nowFolderInfo.hash !== "all") {
        return true;
      } else {
        return false;
      }
    });

    return returnArr;
  };

  const displayInputModal = type => {
    switch (type) {
      case "create":
      case "edit":
        setInputModalType(type);
        setInputModalOpen(true);
        break;

      default:
        console.error(`wrong type => "${type}"`);
        break;
    }
  };

  const handleFolderCreateClick = () => {
    onClose();
    displayInputModal("create");
  };

  const handleFolderEditClick = () => {
    onClose();
    displayInputModal("edit");
  };

  const handleFolderDeleteClick = () => {
    onClose();
    setDeleteConfirmModalOpen(true);
  };

  const handleInputModalClose = () => {
    setInputModalOpen(false);
    setInputFolderName(null);
  };

  const handleInputModalChange = value => {
    setInputFolderName(value);
  };

  const handleSubmit = ({ type }) => {
    if (type === "create") {
      onFolderCreateBtnSubmit(inputFolderName);
      setInputFolderName(null);
    } else if (type === "edit") {
      onFolderEditBtnSubmit({
        folderHash: nowFolderInfo.hash,
        newName: inputFolderName
      });
      setInputFolderName(null);
    }
  };

  const handleDeleteConfirmModalClose = () => {
    setDeleteConfirmModalOpen(false);
  };

  const handleDeleteSubmitClick = () => {
    handleDeleteConfirmModalClose();
    onFolderDeleteBtnSubmit({ folderHash: nowFolderInfo.hash });
  };

  return (
    <div>
      <CommonModalView
        open={open}
        onClose={onClose}
        buttonList={getButtonList()}
        firstButtonText={<TXT name="btnModal_close" />}
        firstButtonFunc={onClose}
      />
      <FolderNameInputModalView
        open={inputModalOpen}
        value={inputFolderName}
        modalType={inputModalType}
        folderName={nowFolderInfo.name}
        onClose={handleInputModalClose}
        onChange={handleInputModalChange}
        onSubmit={handleSubmit}
      />
      <CommonModalView
        open={deleteConfirmModalOpen}
        onClose={handleDeleteConfirmModalClose}
        titleText={
          <TXT
            name="btnList_removeFolder"
            input={{ folderName: nowFolderInfo.name }}
          />
        }
        contentText={<TXT name="msg_deleteFolder" />}
        firstButtonText={<TXT name="btnModal_cancel" />}
        firstButtonFunc={handleDeleteConfirmModalClose}
        secondButtonText={<TXT name="btnModal_delete" />}
        secondButtonTextColor={colorCss.colorOfDanger}
        secondButtonFunc={handleDeleteSubmitClick}
      />
    </div>
  );
}

export default PickAndBookmarkFolderOptModalView;
